import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DEFAULT_APP_CULTURE_CODE } from 'src/app/modules/core/languages/language.model';
import { DocumentReader, TextFieldFormat } from 'src/app/modules/core/store/models';

@Component({
    selector: 'app-culture-code-cell',
    templateUrl: './culture-code-cell.component.html',
    styleUrls: ['./culture-code-cell.component.scss'],
    standalone: false
})
export class CultureCodeCellComponent implements OnInit {
  value: any;

  constructor(private translationService: TranslateService) {}

  ngOnInit(): void {}

  agInit(params: any): void {
    const document = params.data;
    const field = params.schemaField;
    const reader = new DocumentReader(document);

    const data = !!params.data ? reader.getFieldValue(field.systemName) : params.value;

    const value = data ?? DEFAULT_APP_CULTURE_CODE;
    this.value = this.translationService.instant(`LANGUAGES.LANGUAGE-${value}`);
  }
}
